<section *ngIf="show" role="alert" aria-labelledby="commencement-heading">
  <header>
    <h1 class="mb-0" id="commencement-heading">Fall 2026 Housing Move-In </h1>
    <span class="sub-title mb-0">Saturday August 15 - Sunday August 16</span>
  </header>
  <div class="p-2">
    <!-- <a href="https://experience.arcgis.com/experience/3daa1ddd3ac74570b4cbe4dba6ffd2f2">Alumni Weekend Events Map <i class="fas fa-arrow-right ms-4" aria-hidden="true"></i></a> -->
    <p>The areas highlighted indicate increased activity on campus as new and returning students are arriving.</p>
    <div class="container">
      <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
        <div class="col my-auto p-1"><i class="fas fa-square fa-lg" style="color: #149ece"></i> High Traffic Zone</div>
        <div class="col my-auto p-1"><i class="fas fa-square fa-lg" style="color: #a7c636"></i> Limited Availability</div>
        <div class="col my-auto p-1"><i class="fas fa-square fa-lg" style="color: #9e559c"></i> Parking for Move In</div>
        <div class="col my-auto p-1"><i class="fas fa-square fa-lg" style="color: #fc921f"></i> Queuing Location</div>
        <div class="col my-auto p-1"><i class="fas fa-square fa-lg" style="color: #ed5151"></i> Unloading Zone</div>
      </div>
    </div>

  </div>

  <footer>
    <button class="dismiss" (click)="show = false">Dismiss</button>
  </footer>
</section>